const convertBookToBibtex = (item, id) => {
  let result = `\n@book{ref${id}
  `;
  if (item.title)
    result += `title={${item.title}}
  `;
  if (item.publisher)
    result += `publisher={${item.publisher}}
  `;
  if (item.author) {
    let author = [];
    for (let i = 0; i < item.author.length; i++) {
      if (item.author[i].literal)
        author.push(item.author[i].literal)
      else
        author.push(item.author[i].given + ' ' + item.author[i].family)
    }
    result += `author={${author.join(', ')}}
  `;
  }
  if (item.editor) {
    let editor = [];
    for (let i = 0; i < item.editor.length; i++) {
      if (item.editor[i].literal)
        editor.push(item.editor[i].literal)
      else
        editor.push(item.editor[i].given + ' ' + item.editor[i].family)
    }
    result += `editor={${editor.join(', ')}}
  `;
  }
  if (item.issued) {
    result += `year={${item.issued['date-parts'][0][0]}}
  `;
  }
  if (item.volume) {
    result += `volume={${item.volume}}
  `;
  }
  if (item.edition) {
    result += `edition={${item.edition}}
  `;
  }
  if (item['collection-number']) {
    result += `number={${item['collection-number']}}
  `;
  }
  result += `\r}`;
  return result;
}
const convertArticleToBibtex = (item, id) => {
  let result = `\n@article{ref${id}
  `;
  if (item.title)
    result += `title={${item.title}}
  `;
  if (item.publisher)
    result += `publisher={${item.publisher}}
  `;
  if (item.author) {
    let author = [];
    for (let i = 0; i < item.author.length; i++) {
      if (item.author[i].literal)
        author.push(item.author[i].literal)
      else
        author.push(item.author[i].given + ' ' + item.author[i].family)
    }
    result += `author={${author.join(', ')}}
  `;
  }
  if (item.issued) {
    result += `year={${item.issued['date-parts'][0][0]}}
  `;
  }
  if (item.volume) {
    result += `volume={${item.volume}}
  `;
  }
  if (item['collection-number']) {
    result += `number={${item['collection-number']}}
  `;
  }
  result += `\r}`;
  return result;
}
const convertThesisToBibtex = (item, id) => {
  let result = `\n@phdthesis{ref${id}
  `;
  if (item.title)
    result += `title={${item.title}}
  `;
  if (item.publisher)
    result += `school={${item.publisher}}
  `;
  if (item.author) {
    let author = [];
    for (let i = 0; i < item.author.length; i++) {
      if (item.author[i].literal)
        author.push(item.author[i].literal)
      else
        author.push(item.author[i].given + ' ' + item.author[i].family)
    }
    result += `author={${author.join(', ')}}
  `;
  }
  if (item.issued) {
    result += `year={${item.issued['date-parts'][0][0]}}
  `;
  }
  if (item.volume) {
    result += `volume={${item.volume}}
  `;
  }
  if (item['collection-number']) {
    result += `number={${item['collection-number']}}
  `;
  }
  result += `\r}`;
  return result;
}

const convertCslToBibtex = (data) => {
  let result = '';
  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    switch (item.type) {
      case 'book':
        result += convertBookToBibtex(item, i);
        break;
      case 'article':
      case 'paper-conference':
        result += convertArticleToBibtex(item, i);
        break;
      case 'thesis':
        result += convertThesisToBibtex(item, i);
        break;
      default:
        break;
    }
  }
  return result;
}
const downloadBibtex = (data, filename) => {
  const bib = convertCslToBibtex(data);
  const blob = new Blob(['\ufeff', bib], {
    type: 'text/plain'
  });

  // Specify link url
  var url = 'data:text/plain;charset=utf-8,' + encodeURIComponent(bib);

  // Specify file name
  filename = filename ? filename + '.bib' : 'document.bib';

  // Create download link element
  var downloadLink = document.createElement("a");

  document.body.appendChild(downloadLink);

  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // Create a link to the file
    downloadLink.href = url;
    // Setting the file name
    downloadLink.download = filename;
    //triggering the function
    downloadLink.click();
  }
  document.body.removeChild(downloadLink);
}
module.exports = {
  convertCslToBibtex,
  downloadBibtex,
}